import { Col, Row } from 'antd';
import { NavLink } from 'react-router-dom';
import SettingTableContextProvider from 'src/context/settingsTables.context';
import { FC, useEffect, useState } from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router';
import SettingsTablesInterface from 'src/types/settingsTablesTypes';
import StyleInfinityScroll from 'src/modules/settings/modules/styles/StyleCustomTab.style';
import SubTable from '../commons/subTable';
import SCompanySetupNav from '../companyDetails/styles/companySetupNav.style';
import StyledSettingsTables from './styles/index.styles';
import FlexCol from '../companyDetails/styles/flexCol.style';

interface SetupNavInterface {
  tabs: { label: string; to: string }[];
}

const SetupNav: FC<SetupNavInterface> = ({ tabs }) => (
  <SCompanySetupNav style={{ marginBottom: '0.2rem' }}>
    {tabs.map((link) => (
      <NavLink key={link.to} to={`/settings/${link.to}`}>
        {link.label}
      </NavLink>
    ))}
  </SCompanySetupNav>
);

const SettingsTable: FC<SettingsTablesInterface> = ({
  dataSource,
  onListRender,
  columns,
  handleFilterChange,
  handleUpdateRows,
  handleDeleteRows,
  newRecord,
  createNewRecord,
  resetNewRecord,
  postData,
  tabs,
  title,
  BodyModal,
  titleModalNew,
  titleOnDelete,
  contentOnDelete,
  columnsTeamMember,
  setCurrentRecord,
  isMembersTableOnly,
  searchPlaceholder,
  clickable,
  ...rest
}) => {
  const [record, setRecord] = useState<Record<any, any>>();

  useEffect(() => {
    setCurrentRecord?.(record as Record<any, any>);
  }, [record]);

  const handleClickedRecord = (data: any) => {
    setRecord(data);
  };

  if (isMembersTableOnly) {
    return (
      <SettingTableContextProvider
        data={dataSource}
        columns={columns}
        selectedRecord={record}
        columnsMembers={columnsTeamMember ?? []}
        {...rest}
      >
        <StyledSettingsTables tabs={!!tabs}>
          <div className='tabs-outlet-container'>
            <div className='outlet-container'>
              <Outlet />
            </div>
          </div>
        </StyledSettingsTables>
      </SettingTableContextProvider>
    );
  }

  return (
    <SettingTableContextProvider
      data={dataSource}
      columns={columns}
      selectedRecord={record}
      columnsMembers={columnsTeamMember ?? []}
      {...rest}
    >
      <StyledSettingsTables tabs={!!tabs}>
        <Row>
          <FlexCol sm={{ span: 24 }} md={{ span: 8 }} className='table-container'>
            <StyleInfinityScroll style={{ minHeight: '100%', padding: '0' }}>
              <SubTable
                data={dataSource ?? []}
                onListRender={onListRender}
                columns={columns}
                onFilterChange={handleFilterChange}
                handleUpdateRows={handleUpdateRows}
                onDeleteClick={handleDeleteRows}
                actionCell={['delete']}
                detailsIcon={<DeleteOutlined />}
                headerActions={['edit']}
                editIcon={<EditOutlined />}
                scroll={{ y: '70vh', x: '100%' }}
                id='contacts-table'
                showOptionFilterLeft={false}
                newRecord={newRecord}
                resetNewRecord={resetNewRecord}
                saveNewRecord={createNewRecord}
                postData={postData}
                clickedRecord={handleClickedRecord}
                addWithModal
                notEditWithModal
                allowGlobalEditActive
                total
                BodyModal={BodyModal}
                titleModalNew={titleModalNew}
                titleOnDelete={titleOnDelete}
                contentOnDelete={contentOnDelete}
                columnFilterShown
                searchPlaceholder={searchPlaceholder}
                clickable
              />
            </StyleInfinityScroll>
          </FlexCol>
          <Col sm={{ span: 24 }} md={{ span: 16 }} className='tabs-outlet-container'>
            <div className='tabs-title-container'>
              {tabs ? (
                <SetupNav tabs={tabs} />
              ) : (
                <h2 style={{ color: '#858585', fontSize: 30, fontWeight: '500' }}>
                  {title}: <span style={{ color: '#4B4B4B' }}>{record?.name}</span>
                </h2>
              )}
            </div>
            <div className='outlet-container'>
              <Outlet />
            </div>
          </Col>
        </Row>
      </StyledSettingsTables>
    </SettingTableContextProvider>
  );
};
export default SettingsTable;
